module.exports = __webpack_public_path__ + "img/Generic.90bcae98.svg";